import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"
import HeroSectionV3 from "../components/sections/HeroSectionV3"
import NewsSection from "../components/sections/NewsSection"
import MeSection from "../components/sections/MeSection"
import PublicationSection from "../components/sections/PublicationSection"
import FilmGallery from "../components/sections/FilmGallery"
import Footer from "../components/layout/Footer"

function IndexPage() {
  return (
    <Layout>
      <link rel="stylesheet" href="https://use.typekit.net/mja3ngz.css"></link>
      <SEO title="Home" schema={{
        "@context": "https://schema.org", "@type": "ProfilePage",
        "@id": "https://stevewongv.github.io/#profile", url: "https://stevewongv.github.io/",
        mainEntity: { "@type": "Person", "@id": "https://stevewongv.github.io/#person",
          name: "Tianyu (Steve) Wang", alternateName: ["Tianyu Wang", "Steve Wong"],
          jobTitle: "Research Scientist", worksFor: { "@type": "Organization", name: "Adobe Research" },
          email: "mailto:steve.w.vision@icloud.com",
          sameAs: ["https://research.adobe.com/person/tianyu-steve-wang/", "https://github.com/stevewongv", "https://scholar.google.com/citations?user=yRwZIN8AAAAJ", "https://x.com/VisionSteve"] }
      }} />
      <HeroSectionV3 />
      <NewsSection />
      <MeSection />
      <PublicationSection />
      <FilmGallery />
      <Footer />
    </Layout>
  )
}

export default IndexPage
